import config from './template-previews.config.json';
import manifest from './template-previews.manifest.json';

/**
 * Pre-recorded preview loops for animated templates ("Wow · Live animated" tab).
 *
 * The clips are produced by `npm run record:previews` (scripts/record-template-previews.mjs):
 * each template's full preview is recorded in headless Chromium and encoded to a short muted
 * MP4 (H.264, faststart) + WebM (VP9) loop and a JPEG poster under public/template-previews/.
 * Catalog cards play these lightweight loops instead of mounting the live template.
 */
export interface TemplatePreviewClip {
  mp4: string;
  webm: string;
  poster: string;
  width: number;
  height: number;
  durationSec: number;
  bytes: { mp4: number; webm: number; poster: number };
}

export const TEMPLATE_PREVIEW_BUDGET: { targetBytes: number; maxBytes: number } = config.budget;

/** Templates that move (video / GSAP / WebGL journeys) — listed in template-previews.config.json. */
export const WOW_TEMPLATE_IDS: ReadonlySet<string> = new Set(config.templates.map((t) => t.id));

const clips = (manifest as { templates: Record<string, TemplatePreviewClip> }).templates;

export function isWowTemplate(id: string): boolean {
  return WOW_TEMPLATE_IDS.has(id);
}

export function getTemplatePreview(id: string): TemplatePreviewClip | undefined {
  return Object.prototype.hasOwnProperty.call(clips, id) ? clips[id] : undefined;
}
